import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import BrowserLanguageDetector from 'i18next-browser-languagedetector';
// Add these two lines to your imports at the top
import rwTranslation from './locales/rw/translation.json';
import lnTranslation from './locales/ln/translation.json';
// --- Import translation files ---
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import kiTranslation from './locales/ki/translation.json'; 
import swTranslation from './locales/sw/translation.json'; 

// 1. Declare variables outside the block
let detector;
let detectionOrder;

// Check for React Native environment
const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';

if (isReactNative) {
    // ⭐ CRITICAL FIX: Only run require() logic if strictly RN ⭐
    // This is the cleanest way to prevent Webpack compilation errors
    
    let RNLanguageDetector;
    let AsyncStorage;
    
    try {
        // We now require the modules only when we know we are in RN
        RNLanguageDetector = require('i18next-react-native-async-storage');
        AsyncStorage = require('@react-native-async-storage/async-storage').default; 
    } catch (e) {
        // If this fails (e.g., building RN modules failed), we fall back.
        console.error("RN modules failed to load. Falling back to Browser Detector:", e);
    }
    
    if (RNLanguageDetector && AsyncStorage) {
        detector = RNLanguageDetector;
        detectionOrder = ['asyncStorage'];
        
        detector.type = 'languageDetector';
        detector.asyncStorage = AsyncStorage;
    } else {
        // Fallback to browser detection if RN requires failed
        detector = BrowserLanguageDetector;
        detectionOrder = ['localStorage', 'navigator', 'htmlTag'];
    }
} else {
    // For Web/Browser: use the default browser detector
    detector = BrowserLanguageDetector;
    detectionOrder = ['localStorage', 'navigator', 'htmlTag'];
}


i18n
  .use(detector) // 2. Use the dynamically selected detector
  .use(initReactI18next)
  .init({
    lng: undefined, 
    fallbackLng: 'en', 
    debug: false, 
    
    resources: {
      en: { translation: enTranslation }, 
      fr: { translation: frTranslation },
      ki: { translation: kiTranslation }, 
      sw: { translation: swTranslation }, 
      // 🟢 ADD THESE TWO NEW LINES
  rw: { translation: rwTranslation },
  ln: { translation: lnTranslation }
    },
    
    detection: {
      order: detectionOrder, 
      // Only set asyncStorage cache if we successfully loaded the RN modules
      caches: detector !== BrowserLanguageDetector ? ['asyncStorage'] : ['localStorage'], 
    },
    
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;